module.exports = __webpack_public_path__ + "img/money-bag@2x.60976d8e.png";